import { LogicalFieldMixin } from './mixins.js';

const LogicalCalculation = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <input type="text" readonly placeholder='暂无计算结果' />
    </div>
  `
};

export default LogicalCalculation;
